<template>
  <el-select
    v-model="productId"
    filterable
    remote
    clearable
    placeholder="请输入商品名称精确查询"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="handleChange">
    <el-option
      v-for="item in options"
      :key="item.productId"
      :label="item.productName"
      :value="item.productId">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'EntProductAutoSelect',
  components: {},
  props: {
    value: {
      // type: [Number, null],
      required: true
    },
    productTypes: {
      type: Array,
      default() {
        return [1, 9]
      }
    },
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      options: []
    }
  },
  computed: {
    productId: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  created() { },
  mounted() { },
  methods: {
    handleChange() {
      this.callback && this.callback()
    },
    remoteMethod(query) {
      if (query) {
        this.loading = true
        this.$store.dispatch('product/getproducts', {
          payload: {
            pageNum: 1,
            pageSize: 10000,
            productName: query,
            productTypes: this.productTypes,
            vendorId: null
          },
          success: (res) => {
            this.loading = false
            this.options = res.data.records
          },
          fail: () => {
            this.loading = false
            this.options = []
          }
        })
      } else {
        this.options = []
      }
    }
  }
}
</script>
<style lang="stylus" scoped></style>
